var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClaimsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione-monotone",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 14.064H26c-.551 0-1 .463-1 1.032V19h14v-3.903c0-.57-.447-1.033-1-1.033",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 2C15.432 2 2 15.431 2 32c0 16.568 13.432 30 30 30s30-13.432 30-30C62 15.431 48.568 2 32 2M14.5 50a2 2 0 1 1 .001-4.001A2 2 0 0 1 14.5 50m-.5-7a2 2 0 0 1-2-2V21a2 2 0 0 1 2-2h3.5v24H14m7.5 7a2 2 0 1 1 .001-4.001A2 2 0 0 1 21.5 50m7 0a2 2 0 1 1 .001-4.001A2 2 0 0 1 28.5 50m7 0a2 2 0 1 1 .001-4.001A2 2 0 0 1 35.5 50m7 0a2 2 0 1 1 .001-4.001A2 2 0 0 1 42.5 50m-23-7V19H23v-3.903C23 13.389 24.346 12 26 12h12c1.654 0 3 1.389 3 3.097V19h3.5v24h-25m30 7a2 2 0 1 1 .001-4.001A2 2 0 0 1 49.5 50m2.5-9a2 2 0 0 1-2 2h-3.5V19H50a2 2 0 0 1 2 2v20",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimsIcon);
export default __webpack_public_path__ + "static/media/claimsIcon.5555fc3dbf5227b25fbd5ce9ec5e3415.svg";
export { ForwardRef as ReactComponent };